import whatsappIcon from "../assets/svgs/whatsapp.svg?react";
import instagramIcon from "../assets/svgs/instagram.svg?react";
import tiktokIcon from "../assets/svgs/tiktok.svg?react";
import type {
    PaymentMethodType,
    QuickLinkType,
    SocmedType,
} from "@/types/layout-type";
import type { TranslationType } from "@/types/types";

export const socmed = (wa: string, ig: string, tt: string): SocmedType[] => {
    return [
        {
            name: "WhatsApp",
            svg: whatsappIcon,
            link: `https://wa.me/${wa}`,
        },
        {
            name: "Instagram",
            svg: instagramIcon,
            link: `https://www.instagram.com/${ig}`,
        },
        {
            name: "Tiktok",
            svg: tiktokIcon,
            link: `https://www.tiktok.com/@${tt}`,
        },
    ];
};

export const quickLink = (t: TranslationType): QuickLinkType[] => [
    {
        name: t("footer.quick_link.about_me"),
        link: "about",
    },
    {
        name: t("footer.quick_link.katalog"),
        link: "shop",
    },
    {
        name: t("footer.quick_link.farm"),
        link: "farm",
    },
    {
        name: t("footer.quick_link.payment_guide"),
        link: "payment-guide",
    },
    {
        name: t("footer.quick_link.faq"),
        link: "about#faq",
    },
    {
        name: t("footer.quick_link.tnc", "Syarat & Ketentuan"),
        link: "terms-and-conditions",
    },
];

export const paymentMethod: PaymentMethodType[] = [
    {
        name: "BNI",
        src: "/assets/payment-logo/bni.png",
        height: "h-4",
    },
    {
        name: "BCA",
        src: "/assets/payment-logo/bca.png",
        height: "h-5",
    },
    {
        name: "BRI Virtual Account",
        src: "/assets/payment-logo/briva.png",
        height: "h-5",
    },
    {
        name: "DANA",
        src: "/assets/payment-logo/dana.png",
        height: "h-6",
    },
    {
        name: "OVO",
        src: "/assets/payment-logo/ovo.png",
        height: "h-5",
    },
    {
        name: "ShopeePay",
        src: "/assets/payment-logo/spay.png",
        height: "h-6",
    },
    {
        name: "QRIS",
        src: "/assets/payment-logo/qris.webp",
        height: "h-8",
    },
    {
        name: "DuitNow QR (Malaysia)",
        src: "/assets/payment-logo/duitnow.webp",
        height: "h-9",
    },
    {
        name: "Mastercard",
        src: "/assets/payment-logo/mastercard.webp",
        height: "h-9",
    },
    {
        name: "Visa",
        src: "/assets/payment-logo/visa.png",
        height: "h-7",
    },
    {
        name: "JCB",
        src: "/assets/payment-logo/jcb.png",
        height: "h-7",
    },
    {
        name: "American Express",
        src: "/assets/payment-logo/ae.webp",
        height: "h-7",
    },
];
